/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import { RangeControl, SelectControl, TextControl } from '@wordpress/components';

/**
 * Inner dependencies.
 */
import Accordion from '../../../components/Accordion';
import blockConst from '../constants';

const { hookPrefix, mapLanguages } = blockConst;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-content`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content`,
	( content, props ) => {
		const { attributes, setAttributes } = props;
		const { zoom, language, height } = attributes;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion tabs={ [
					{
						name: 'map',
						initialOpen: true,
						label: () => {
							return __( 'Map' );
						},
						cb: () => {
							return <>
								<TextControl
									label={ __( 'Height Level' ) }
									onChange={ ( value ) => {
										setAttributes( { height: parseInt( value, 10 ) } );
									} }
									type="number"
									value={ height }
									min={ 200 }
									step={ 10 } />
								<RangeControl
									label={ __( 'Zoom Level' ) }
									value={ zoom }
									onChange={ ( value ) => {
										setAttributes( { zoom: value } );
									} }
									min={ 5 }
									max={ 20 }
									step={ 1 } />
								<SelectControl
									label={ __( 'Language', 'gutenify' ) }
									value={ language }
									onChange={ ( value ) => setAttributes( { language: value } ) }
									options={ mapLanguages }
								/>
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);
